import { Box, Button, Group, LoadingOverlay, Text } from "@mantine/core";
import { LockIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import useSwr from "swr";
import { OrderApi } from "../../apis";
import { OrderForm } from "../../components/order";
import { EDITABLE_ORDER_STATUSES } from "../../components/buyer-sales-list/order-row-actions";
import { OrderStatusPill } from "../../components/buyer-sales/order-status-pill";
import classes from "./edit.module.css";

export function BuyerSalesEdit() {
  const params = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation(["order", "common"]);

  const { data, isLoading } = useSwr(`/ord/order/buyer/get.${params.id}`, async () => await OrderApi.get(params.id as string), {
    fallback: { data: null },
  });

  // B36: the server edits only DRAFT / REGISTERED / REVIEW_REJECTED orders the buyer
  // sent (routes/api/order/update.ts) and answers anything else with «not found»;
  // a sent order opened by URL says so instead of offering a form that cannot save.
  const editable = !!data && data.type !== "SALES" && EDITABLE_ORDER_STATUSES.includes(data.orderStatus);

  return (
    <>
      <LoadingOverlay visible={isLoading && !data} />
      {data && editable && <OrderForm mode="edit" side="buyer" data={data} />}
      {data && !editable && (
        <Box className={classes.card}>
          <Group gap="md" align="flex-start" wrap="nowrap">
            <Box component="span" className={classes.icon}>
              <LockIcon size={22} />
            </Box>
            <Box>
              <Group gap="sm" mb={4}>
                <Text fw={700} fz="var(--nw-fz-card)" translate="no">
                  {data.purchaseCode || data.salesCode || "-"}
                </Text>
                <OrderStatusPill order={data} />
              </Group>
              <Text fw={650} fz="var(--nw-fz-lead)">{t("order:buyerOrders.edit.notEditableTitle")}</Text>
              <Text className={classes.text}>{t("order:buyerOrders.edit.notEditableText")}</Text>
              <Group gap="sm" mt="md">
                <Button onClick={() => navigate(`/buyer-sales/detail/${data.id}`)}>{t("order:buyerOrders.edit.openDetail")}</Button>
                <Button variant="default" onClick={() => navigate("/buyer-sales")}>
                  {t("common:actions.back")}
                </Button>
              </Group>
            </Box>
          </Group>
        </Box>
      )}
    </>
  );
}
